import React from "react";
import { Card, Banner } from "@shopify/polaris";
import { Col } from "reactstrap";
import config from "../../config/config";
const Step = () => {
	return (
		<Col className="privacy d-flex" xs="12" sm="12" md="4">
			<Card
				title="Step by step video to connect to your account"
				sectioned
			>
				<div>
					<div className="mt-4">
						<iframe
							src="https://www.youtube.com/embed/939S7HqgJi4"
							frameBorder="0"
							allow="autoplay; encrypted-media"
							allowFullScreen
							title="Video Tutorial"
							width="100%"
							height="300"
						/>
					</div>
					<Banner status="default">
						<p
							className="text-left"
							style={{ lineHeight: "26px", fontSize: "15px" }}
						>
							We only require <b>minimal access </b> from your
							account to add tracking info to Paypal. Rest assured
							that your account will <b>always be safe</b>
						</p>
					</Banner>
				</div>
			</Card>
		</Col>
	);
};

export default Step;
